import React, {useEffect} from "react";
import "./FAQPage.css";
import {PanelBar, PanelBarItem, TabStrip, TabStripTab} from "@progress/kendo-react-layout";
import create_audiences from  "../Components/Segmentation/temporaryresources/faqimages/create_audiences.png";
import activate_segment from  "../Components/Segmentation/temporaryresources/faqimages/activate_segment.png";
import onboarding_filetypedropdown from "../Components/Segmentation/temporaryresources/faqimages/onboarding_filetypedropdown.jpeg"
import address from "../Components/Segmentation/temporaryresources/docs/address.csv";
import haddress from "../Components/Segmentation/temporaryresources/docs/address.csv";
import companyAddress from "../Components/Segmentation/temporaryresources/docs/company_name_and_address.txt";
import email from "../Components/Segmentation/temporaryresources/docs/email.csv";
import sha256Email from "../Components/Segmentation/temporaryresources/docs/sha256_email.csv";
import sha1Email from "../Components/Segmentation/temporaryresources/docs/sha1_email.csv";
import md5Email from "../Components/Segmentation/temporaryresources/docs/md5_email.csv";
import xandrId from "../Components/Segmentation/temporaryresources/docs/xandr_id.csv";
import deviceId from "../Components/Segmentation/temporaryresources/docs/device_id.csv";
import dma from "../Components/Segmentation/temporaryresources/docs/dma.csv";
import npiId from "../Components/Segmentation/temporaryresources/docs/npi_id.csv";
import impressions from "../Components/Segmentation/temporaryresources/docs/impressions.csv";
import usPhone from "../Components/Segmentation/temporaryresources/docs/us_phone.csv";
import domainName from "../Components/Segmentation/temporaryresources/docs/domain_name.csv";
import company_name_and_naics from "../Components/Segmentation/temporaryresources/docs/company_name_and_naics.csv";
import zip5 from "../Components/Segmentation/temporaryresources/docs/zip5.txt";
import zip9 from "../Components/Segmentation/temporaryresources/docs/zip9.txt";
import zip11 from "../Components/Segmentation/temporaryresources/docs/zip11.txt";
import datatrust from "../Components/Segmentation/temporaryresources/docs/datatrust_id.csv";
import freewheel from "../Components/Segmentation/temporaryresources/docs/freewheel_ids.csv";
import latLong from "../Components/Segmentation/temporaryresources/docs/lat_long.csv";
import purplelab from "../Components/Segmentation/temporaryresources/docs/PurpleLabID.csv";
import voterId from "../Components/Segmentation/temporaryresources/docs/voter_id.csv";
import L2DataVoter from "../Components/Segmentation/temporaryresources/docs/l2_data_voter_id.csv";
import healthwise from "../Components/Segmentation/temporaryresources/docs/healthwise_keys.csv";
import i360_id from "../Components/Segmentation/temporaryresources/docs/i360_id.csv";
import mriid from "../Components/Segmentation/temporaryresources/docs/mri_id.csv";
import pdi from "../Components/Segmentation/temporaryresources/docs/pdi_id.csv";
import internetKeywords from "../Components/Segmentation/temporaryresources/docs/internet_keywords.csv";
import internetSites from "../Components/Segmentation/temporaryresources/docs/internet_sites.csv";
import audienceacuity from "../Components/Segmentation/temporaryresources/docs/audienceacuity_id.csv";
import semcastingid from "../Components/Segmentation/temporaryresources/docs/persistent_id.csv";
import pubmatic from "../Components/Segmentation/temporaryresources/docs/pubmatic_id.csv";

const dmaRows = [
    {"code": "500", "name": "Portland-Auburn ME"},
    {"code": "501", "name": "New York NY"},
    {"code": "502", "name": "Binghamton NY"},
    {"code": "503", "name": "Macon GA"},
    {"code": "504", "name": "Philadelphia PA"},
    {"code": "505", "name": "Detroit MI"},
    {"code": "506", "name": "Boston MA (Manchester NH)"},
    {"code": "507", "name": "Savannah GA"},
    {"code": "508", "name": "Pittsburgh PA"},
    {"code": "509", "name": "Ft. Wayne IN"},
    {"code": "510", "name": "Cleveland-Akron (Canton) OH"},
    {"code": "511", "name": "Washington DC (Hagerstown MD)"},
    {"code": "512", "name": "Baltimore MD"},
    {"code": "513", "name": "Flint-Saginaw-Bay City MI"},
    {"code": "514", "name": "Buffalo NY"},
    {"code": "515", "name": "Cincinnati OH"},
    {"code": "516", "name": "Erie PA"},
    {"code": "517", "name": "Charlotte NC"},
    {"code": "518", "name": "Greensboro-High Point-Winston Salem NC"},
    {"code": "519", "name": "Charleston SC"},
    {"code": "520", "name": "Augusta GA-Aiken SC"},
    {"code": "521", "name": "Providence RI-New Bedford MA"},
    {"code": "522", "name": "Columbus GA (Opelika AL)"},
    {"code": "523", "name": "Burlington VT-Plattsburgh NY"},
    {"code": "524", "name": "Atlanta GA"},
    {"code": "525", "name": "Albany GA"},
    {"code": "526", "name": "Utica NY"},
    {"code": "527", "name": "Indianapolis IN"},
    {"code": "528", "name": "Miami-Ft. Lauderdale FL"},
    {"code": "529", "name": "Louisville KY"},
    {"code": "530", "name": "Tallahassee FL-Thomasville GA"},
    {"code": "531", "name": "Tri-Cities TN-VA"},
    {"code": "532", "name": "Albany-Schenectady-Troy NY"},
    {"code": "533", "name": "Hartford & New Haven CT"},
    {"code": "534", "name": "Orlando-Daytona Beach-Melbourne FL"},
    {"code": "535", "name": "Columbus OH"},
    {"code": "536", "name": "Youngstown OH"},
    {"code": "537", "name": "Bangor ME"},
    {"code": "538", "name": "Rochester NY"},
    {"code": "539", "name": "Tampa-St. Petersburg (Sarasota) FL"},
    {"code": "540", "name": "Traverse City-Cadillac MI"},
    {"code": "541", "name": "Lexington KY"},
    {"code": "542", "name": "Dayton OH"},
    {"code": "543", "name": "Springfield-Holyoke MA"},
    {"code": "544", "name": "Norfolk-Portsmouth-Newport News VA"},
    {"code": "545", "name": "Greenville-New Bern-Washington NC"},
    {"code": "546", "name": "Columbia SC"},
    {"code": "547", "name": "Toledo OH"},
    {"code": "548", "name": "West Palm Beach-Ft. Pierce FL"},
    {"code": "549", "name": "Watertown NY"},
    {"code": "550", "name": "Wilmington NC"},
    {"code": "551", "name": "Lansing MI"},
    {"code": "552", "name": "Presque Isle ME"},
    {"code": "553", "name": "Marquette MI"},
    {"code": "554", "name": "Wheeling WV-Steubenville OH"},
    {"code": "555", "name": "Syracuse NY"},
    {"code": "556", "name": "Richmond-Petersburg VA"},
    {"code": "557", "name": "Knoxville TN"},
    {"code": "558", "name": "Lima OH"},
    {"code": "559", "name": "Bluefield-Beckley-Oak Hill WV"},
    {"code": "560", "name": "Raleigh-Durham (Fayetteville) NC"},
    {"code": "561", "name": "Jacksonville FL"},
    {"code": "563", "name": "Grand Rapids-Kalamazoo-Battle Creek MI"},
    {"code": "564", "name": "Charleston-Huntington WV"},
    {"code": "565", "name": "Elmira (Corning) NY"},
    {"code": "566", "name": "Harrisburg-Lancaster-Lebanon-York PA"},
    {"code": "567", "name": "Greenville-Spartanburg SC-Asheville NC-Anderson SC"},
    {"code": "569", "name": "Harrisonburg VA"},
    {"code": "570", "name": "Myrtle Beach-Florence SC"},
    {"code": "571", "name": "Ft. Myers-Naples FL"},
    {"code": "573", "name": "Roanoke-Lynchburg VA"},
    {"code": "574", "name": "Johnstown-Altoona-State College PA"},
    {"code": "575", "name": "Chattanooga TN"},
    {"code": "576", "name": "Salisbury MD"},
    {"code": "577", "name": "Wilkes Barre-Scranton-Hazleton PA"},
    {"code": "581", "name": "Terre Haute IN"},
    {"code": "582", "name": "Lafayette IN"},
    {"code": "583", "name": "Alpena MI"},
    {"code": "584", "name": "Charlottesville VA"},
    {"code": "588", "name": "South Bend-Elkhart IN"},
    {"code": "592", "name": "Gainesville FL"},
    {"code": "596", "name": "Zanesville OH"},
    {"code": "597", "name": "Parkersburg WV"},
    {"code": "598", "name": "Clarksburg-Weston WV"},
    {"code": "600", "name": "Corpus Christi TX"},
    {"code": "602", "name": "Chicago IL"},
    {"code": "603", "name": "Joplin MO-Pittsburg KS"},
    {"code": "604", "name": "Columbia-Jefferson City MO"},
    {"code": "605", "name": "Topeka KS"},
    {"code": "606", "name": "Dothan AL"},
    {"code": "609", "name": "St. Louis MO"},
    {"code": "610", "name": "Rockford IL"},
    {"code": "611", "name": "Rochester MN-Mason City IA-Austin MN"},
    {"code": "612", "name": "Shreveport LA"},
    {"code": "613", "name": "Minneapolis-St. Paul MN"},
    {"code": "616", "name": "Kansas City MO"},
    {"code": "617", "name": "Milwaukee WI"},
    {"code": "618", "name": "Houston TX"},
    {"code": "619", "name": "Springfield MO"},
    {"code": "622", "name": "New Orleans LA"},
    {"code": "623", "name": "Dallas-Ft. Worth TX"},
    {"code": "624", "name": "Sioux City IA"},
    {"code": "625", "name": "Waco-Temple-Bryan TX"},
    {"code": "626", "name": "Victoria TX"},
    {"code": "627", "name": "Wichita Falls TX & Lawton OK"},
    {"code": "628", "name": "Monroe LA-El Dorado AR"},
    {"code": "630", "name": "Birmingham (Anniston and Tuscaloosa) AL"},
    {"code": "631", "name": "Ottumwa IA-Kirksville MO"},
    {"code": "632", "name": "Paducah KY-Cape Girardeau MO-Harrisburg IL"},
    {"code": "633", "name": "Odessa-Midland TX"},
    {"code": "634", "name": "Amarillo TX"},
    {"code": "635", "name": "Austin TX"},
    {"code": "636", "name": "Harlingen-Weslaco-Brownsville-McAllen TX"},
    {"code": "637", "name": "Cedar Rapids-Waterloo-Iowa City & Dubuque IA"},
    {"code": "638", "name": "St. Joseph MO"},
    {"code": "639", "name": "Jackson TN"},
    {"code": "640", "name": "Memphis TN"},
    {"code": "641", "name": "San Antonio TX"},
    {"code": "642", "name": "Lafayette LA"},
    {"code": "643", "name": "Lake Charles LA"},
    {"code": "644", "name": "Alexandria LA"},
    {"code": "647", "name": "Greenwood-Greenville MS"},
    {"code": "648", "name": "Champaign & Springfield-Decatur IL"},
    {"code": "649", "name": "Evansville IN"},
    {"code": "650", "name": "Oklahoma City OK"},
    {"code": "651", "name": "Lubbock TX"},
    {"code": "652", "name": "Omaha NE"},
    {"code": "656", "name": "Panama City FL"},
    {"code": "657", "name": "Sherman TX-Ada OK"},
    {"code": "658", "name": "Green Bay-Appleton WI"},
    {"code": "659", "name": "Nashville TN"},
    {"code": "661", "name": "San Angelo TX"},
    {"code": "662", "name": "Abilene-Sweetwater TX"},
    {"code": "669", "name": "Madison WI"},
    {"code": "670", "name": "Ft. Smith-Fayetteville-Springdale-Rogers AR"},
    {"code": "671", "name": "Tulsa OK"},
    {"code": "673", "name": "Columbus-Tupelo-West Point-Houston MS"},
    {"code": "675", "name": "Peoria-Bloomington IL"},
    {"code": "676", "name": "Duluth MN-Superior WI"},
    {"code": "678", "name": "Wichita-Hutchinson KS Plus"},
    {"code": "679", "name": "Des Moines-Ames IA"},
    {"code": "682", "name": "Davenport IA-Rock Island-Moline IL"},
    {"code": "686", "name": "Mobile AL-Pensacola (Ft. Walton Beach) FL"},
    {"code": "687", "name": "Minot-Bismarck-Dickinson (Williston) ND"},
    {"code": "691", "name": "Huntsville-Decatur (Florence) AL"},
    {"code": "692", "name": "Beaumont-Port Arthur TX"},
    {"code": "693", "name": "Little Rock-Pine Bluff AR"},
    {"code": "698", "name": "Montgomery-Selma AL"},
    {"code": "702", "name": "La Crosse-Eau Claire WI"},
    {"code": "705", "name": "Wausau-Rhinelander WI"},
    {"code": "709", "name": "Tyler-Longview (Lufkin & Nacogdoches) TX"},
    {"code": "710", "name": "Hattiesburg-Laurel MS"},
    {"code": "711", "name": "Meridian MS"},
    {"code": "716", "name": "Baton Rouge LA"},
    {"code": "717", "name": "Quincy IL-Hannibal MO-Keokuk IA"},
    {"code": "718", "name": "Jackson MS"},
    {"code": "722", "name": "Lincoln & Hastings-Kearney NE"},
    {"code": "724", "name": "Fargo-Valley City ND"},
    {"code": "725", "name": "Sioux Falls (Mitchell) SD"},
    {"code": "734", "name": "Jonesboro AR"},
    {"code": "736", "name": "Bowling Green KY"},
    {"code": "737", "name": "Mankato MN"},
    {"code": "740", "name": "North Platte NE"},
    {"code": "743", "name": "Anchorage AK"},
    {"code": "744", "name": "Honolulu HI"},
    {"code": "745", "name": "Fairbanks AK"},
    {"code": "746", "name": "Biloxi-Gulfport MS"},
    {"code": "747", "name": "Juneau AK"},
    {"code": "749", "name": "Laredo TX"},
    {"code": "751", "name": "Denver CO"},
    {"code": "752", "name": "Colorado Springs-Pueblo CO"},
    {"code": "753", "name": "Phoenix (Prescott) AZ"},
    {"code": "754", "name": "Butte-Bozeman MT"},
    {"code": "755", "name": "Great Falls MT"},
    {"code": "756", "name": "Billings MT"},
    {"code": "757", "name": "Boise ID"},
    {"code": "758", "name": "Idaho Falls-Pocatello (Jackson WY) ID"},
    {"code": "759", "name": "Cheyenne WY-Scottsbluff NE"},
    {"code": "760", "name": "Twin Falls ID"},
    {"code": "762", "name": "Missoula MT"},
    {"code": "764", "name": "Rapid City SD"},
    {"code": "765", "name": "El Paso (Las Cruces) TX"},
    {"code": "766", "name": "Helena MT"},
    {"code": "767", "name": "Casper-Riverton WY"},
    {"code": "770", "name": "Salt Lake City UT"},
    {"code": "771", "name": "Yuma AZ-El Centro CA"},
    {"code": "773", "name": "Grand Junction-Montrose CO"},
    {"code": "789", "name": "Tucson (Sierra Vista) AZ"},
    {"code": "790", "name": "Albuquerque-Santa Fe NM"},
    {"code": "798", "name": "Glendive MT"},
    {"code": "800", "name": "Bakersfield CA"},
    {"code": "801", "name": "Eugene OR"},
    {"code": "802", "name": "Eureka CA"},
    {"code": "803", "name": "Los Angeles CA"},
    {"code": "804", "name": "Palm Springs CA"},
    {"code": "807", "name": "San Francisco-Oakland-San Jose CA"},
    {"code": "810", "name": "Yakima-Pasco-Richland-Kennewick WA"},
    {"code": "811", "name": "Reno NV"},
    {"code": "813", "name": "Medford-Klamath Falls OR"},
    {"code": "819", "name": "Seattle-Tacoma WA"},
    {"code": "820", "name": "Portland OR"},
    {"code": "821", "name": "Bend OR"},
    {"code": "825", "name": "San Diego CA"},
    {"code": "828", "name": "Monterey-Salinas CA"},
    {"code": "839", "name": "Las Vegas NV"},
    {"code": "855", "name": "Santa Barbara-Santa Maria-San Luis Obispo CA"},
    {"code": "862", "name": "Sacramento-Stockton-Modesto CA"},
    {"code": "866", "name": "Fresno-Visalia CA"},
    {"code": "868", "name": "Chico-Redding CA"},
    {"code": "881", "name": "Spokane WA"},
];

const FAQPage = (loggedIn) => {
    const [selected, setSelected] = React.useState(0);
    const [dmaSearch, setDmaSearch] = React.useState("");
    const [debouncedDmaSearch, setDebouncedDmaSearch] = React.useState("");

    useEffect(() => {
        const timeout = setTimeout(() => setDebouncedDmaSearch(dmaSearch), 300);
        return () => clearTimeout(timeout);
    }, [dmaSearch]);

    const filteredDmaRows = dmaRows.filter((row) =>
        row.name.toLowerCase().includes(debouncedDmaSearch.trim().toLowerCase())
    );
    const resetDmaSearch = () => {
        setDmaSearch("");
        setDebouncedDmaSearch("");
    };
    const handleSelect = (e) => {
        if (e.selected !== selected) resetDmaSearch();
        setSelected(e.selected);
    };
    useEffect(() => {

    }, []);

    return (
        <React.Fragment>
        <div className={"faq-page-container"}>
            <TabStrip
                selected={selected}
                onSelect={handleSelect}
                tabPosition={"left"}
            >
                <TabStripTab title="Onboarding">
                    <div className="panelbar-wrapper">
                        <PanelBar expandMode={"single"} onSelect={resetDmaSearch}>
                            <PanelBarItem expanded={true} title="I uploaded a list of 1,756 addresses, but ADS matched 15,248 Households. Why did this happen?">
                                <div>
                                    <p>
                                        There could be several reasons for this discrepancy. One possibility is that the match happened on a broader scale, such as ZIP+9, which could result in multiple addresses being associated with a single input address. It’s important to verify the match key used.
                                    </p>
                                    <p>
                                        Sometimes, ADS might default to a less specific match type, like ZIP code, if it doesn’t recognize the address column properly. It's recommended to double-check the file before uploading to ensure the address column is correctly formatted, and you can also contact support for assistance.
                                    </p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title={"Best Practices for Onboarding First Party Data?"} className={"question"}>
                                <div>
                                    <ul>
                                        <li>Remove:</li>
                                            <ul>
                                                <li>Double Spaces.</li>
                                                <li>Symbols such as , . - / # : .</li>
                                                <li>Extra blank rows.</li>
                                                <li>Duplicates (the system does remove them but your overall MR will show higher in the platform if you remove them prior to loading).</li>
                                                <li>If your file has both a mailing and residential address listed, delete the mailing address and match to the residential address only. Typically mailing addresses contain PO Boxes which are not matchable.</li>
                                            </ul>
                                        <li>Tips/Tricks:</li>
                                            <ul>
                                                <li>We don't match on PO boxes, first/last names, or locations outside of US.</li>
                                                <li>Please make sure 0 is added to the front of specific zip codes in your file or they will not match (Save file as TXT).</li>
                                                <li>If you are matching on addresses, make sure address, city, state and zip are in 4 separate fields.</li>
                                                <li>Address 2 should be in a separate field to ensure higher match rates. The system does not recognize unit, suite, apt etc. in the Address 1 line.</li>
                                                <li>
                                                    If you have emails and addresses in the same file, you can either split them into individual files to match on each, or you will need to onboard the same file twice, choose address the first time and email the second (see screenshot below). This is the same for all other data (phone numbers, company names, etc.).
                                                    <div className={"image-wrapper"}>
                                                        <img
                                                            src={onboarding_filetypedropdown}
                                                            alt="image"
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                    </ul>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="What file types do you accept?">
                                <div>
                                    <p>File extension needs to be one of the following: csv, tsv, txt, and log.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="What file formats do you accept?">
                                <div className={"accepted-file-format-list"}>
                                    <p>
                                        <p>Below are the sample formats we accept in Onboarding > Create Segment > My Computer. Click on the link to download a sample file.</p>
                                        <div>
                                            <ul>
                                                <li><a href={address} download="address.csv">Address</a></li>
                                                <li><a href={audienceacuity} download="audienceacuity_id.csv">Audience Acuity ID</a></li>
                                                <li><a href={companyAddress} download="company_name_address.csv">Company Name and Address</a></li>
                                                <li><a href={company_name_and_naics} download="company_name_naics.csv">Company Name and Naics Code</a></li>
                                                <li><a href={latLong} download="lat_long.csv">Coordinates</a></li>
                                                <li><a href={datatrust} download="datatrust_id.csv">DataTrust ID</a></li>
                                                <li><a href={deviceId} download="device_id.csv">Device ID</a></li>
                                                <li><a href={domainName} download="domain_name.csv">Domain Name</a></li>
                                                <li><a href={email} download="email.csv">Email</a></li>
                                                <li><a href={freewheel} download="freewheel_ids.csv">FreeWheel ID</a></li>
                                                <li><a href={haddress} download="humana_address.csv">H* Address</a></li>
                                                <li><a href={healthwise} download="healthwise_keys.csv">HealthWise ID</a></li>
                                                <li><a href={i360_id} download="i360_id.csv">i360 ID</a></li>
                                                <li><a href={internetKeywords} download="internet_keyword.csv">Internet Keyword</a></li>
                                                <li><a href={internetSites} download="internet_sites.csv">Internet Sites</a></li>
                                                <li><a href={impressions} download="impressions.csv">IP and Timestamp</a></li>
                                                <li><a href={L2DataVoter} download="l2data_voter_id.csv">L2Data Voter ID</a></li>
                                                <li><a href={md5Email} download="md5_email.csv">Md5 Email</a></li>
                                                <li><a href={mriid} download="mri_id.csv">MRI ID</a></li>
                                                <li><a href={npiId} download="npi_id.csv">NPI ID</a></li>
                                                <li><a href={pdi} download="pdi_id.csv">PDI ID</a></li>
                                                <li><a href={usPhone} download="us_phone.csv">Phone Number</a></li>
                                                <li><a href={pubmatic} download="pubmatic_id.csv">PubMatic ID</a></li>
                                                <li><a href={purplelab} download="purple-md5.csv">Purple Md5 ID</a></li>
                                                <li><a href={semcastingid} download="persistent_id.csv">Semcasting ID</a></li>
                                                <li><a href={sha1Email} download="sha1_email.csv">Sha1 Email</a></li>
                                                <li><a href={sha256Email} download="sha256_email.csv">Sha256 Email</a></li>
                                                <li><a href={voterId} download="voter_id.csv">Voter ID</a></li>
                                                <li><a href={xandrId} download="xandr_id.csv">Xandr ID</a></li>
                                                <li><a href={zip5} download="zip5.csv">5 Digit Zip Codes</a></li>
                                                <li><a href={zip9} download="zip9.csv">9 Digit Zip Codes</a></li>
                                                <li><a href={zip11} download="zip11.csv">11 Digit Zip Codes</a></li>
                                            </ul>
                                        </div>
                                    </p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="How do I upload my 1st Party Data into the platform?">
                                <div>
                                    <p>You can either upload directly from your computer or through an FTP or S3 server.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="What is the max file size for onboarding?">
                                <div>
                                    <p>2GB.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="Is there a minimum file size for onboarding and matching?">
                                <div>
                                    <p>Consumer Records need to have 1,000 unique records.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="When merging files, what is the difference between common and distinct?">
                                <div>
                                    <p>Common will merge the identical records in each segment, ie AND statement.</p>
                                    <p>Distinct will merge all records into a new segment; ie OR statement.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="What Match Keys are available?">
                                <div>
                                    <p>We have over a dozen match keys available on our platform. These include: Zip Code, Address, Company name and address, Email, NPI, IP and Timestamp, Phone Number, Domain Name, NAICS code, Keywords, and various IDs.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="What DMA codes are available?">
                                <div>
                                    <p>DMA names and formatting may differ by platform. Before using this list in IDX or a DSP upload, confirm the codes and names against the destination platform's current taxonomy. Where numeric DMA codes are supported, use <code>dma_code</code> rather than <code>dma_name</code> as the join key to avoid name mismatches.</p>
                                    <p><a href={dma} download="dma.csv">Download DMA codes (CSV)</a></p>
                                    <div className="dma-search">
                                        <label htmlFor="dma-name-search">Search dma_name</label>
                                        <input
                                            id="dma-name-search"
                                            type="search"
                                            value={dmaSearch}
                                            onChange={(event) => setDmaSearch(event.target.value)}
                                            placeholder="Enter a DMA name"
                                        />
                                    </div>
                                    <div className="dma-table-wrapper" role="region" aria-label="DMA codes" tabIndex={0}>
                                        <table className="dma-table">
                                            <caption>DMA codes and names</caption>
                                            <thead>
                                                <tr><th scope="col">dma_code</th><th scope="col">dma_name</th></tr>
                                            </thead>
                                            <tbody>
                                                {filteredDmaRows.map((row) => (
                                                    <tr key={row.code}><td>{row.code}</td><td>{row.name}</td></tr>
                                                ))}
                                                {filteredDmaRows.length === 0 && (
                                                    <tr><td colSpan={2}>No matching DMA names found.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </PanelBarItem>
                        </PanelBar>
                    </div>
                </TabStripTab>
                <TabStripTab title="Measurement">
                    <div className="panelbar-wrapper">
                        <PanelBar expandMode={"single"}>
                            <PanelBarItem expanded={true} title={"Does the impression tracker for real-time measurement work on every campaign?"} className={"question"}>
                                <div>
                                    <p>The impression tracker for real time measurement can NOT be used for Facebook campaigns or Linear TV campaigns.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="Why is there a discrepancy between the number of impressions from the exposure file and the DSP?">
                                <div>
                                    <p>
                                        When exporting an exposure file of those served an ad via measurement, the impression count may be lower than the total in the DSP, as the measurement exposure in ADS will only take into account the individuals in the audience served, where as the DSP may serve to ads to individuals seen at a different IP or location at that time that are not included in your audience.
                                    </p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="How do I get my unmatched records back?">
                                <div>
                                    <p>Step 1: If you haven't done so, setup a new FTP or S3 connection in Admin Settings > Connections Manager. You can also select a connection and in the Edit dialogue, test the connection to make sure it is still valid.</p>
                                    <p>Step 2: When doing an Onboarding,  under the About Audience section, select the designated FTP connection under Direct Non-Match File to Connection.</p>
                                    <p>Step 3: Once the Onboarding process is submitted and completed, the unmatched records will be exported into the designated FTP.</p>
                                </div>
                            </PanelBarItem>
                        </PanelBar>
                    </div>
                </TabStripTab>
                <TabStripTab title="Activation">
                    <div className="panelbar-wrapper">
                        <PanelBar expandMode={"single"}>
                            <PanelBarItem expanded={true} title={"Can you also please let us know what is the secret key or how do I get it for the StackAdapt activation?"} className={"question"}>
                                <div>
                                    <p>You will need to get the Secret Key from your contact at StackAdapt. Let them know you need an API Secret Key to use with Audience Designer. It should be a 32-character string.</p>
                                </div>
                            </PanelBarItem>
                        </PanelBar>
                    </div>
                </TabStripTab>
                <TabStripTab title="Settings/Accounts">
                    <div className="panelbar-wrapper">
                        <PanelBar expandMode={"single"}>
                            <PanelBarItem title="How do I add new users?" expanded={true}>
                                <div>
                                    <p>Only the account Admin has this permission. Go into Settings > Permissions > Users > + New.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="Is there a max number of users I can add to my account?">
                                <div>
                                    <p>There is no maximum number of users to add to the Admin account.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="What is a Group?">
                                <div>
                                    <p>A Group has many different organizational purposes. Think of it as a folder or file directory. Agencies can make separate Groups for their different clients or campaigns. Brands can make separate Groups divided by campaigns if they have multiple segments running at once.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="Can I create an account for my client to onboard their file directly into ADS?">
                                <div>
                                    <p>Yes. We also recommend that you create a new Group and assign this new user account to this specific Group to ensure that they are only seeing their own segments.</p>
                                    <p>To achieve this, create a new Group first, then, create a new User and assign the corresponding Role to this user in the desired Group.</p>
                                </div>
                            </PanelBarItem>
                            <PanelBarItem title="Can I save segments to multiple groups?">
                                <div>
                                    <p>You can achieve this by repeating the segment creation process and saving it to different Groups by changing the value of "Save to Group".</p>
                                </div>
                            </PanelBarItem>
                        </PanelBar>
                    </div>
                </TabStripTab>
            </TabStrip>
        </div>
        </React.Fragment>
    );
};

export default FAQPage;
